import { useQuery } from 'react-query';
import {
  getBettieDailyCheckInStatus,
  type GetBettieDailyCheckInStatusResponse
} from '../../services/bettieService';

export function useGetBettieDailyCheckInStatus() {
  return useQuery<GetBettieDailyCheckInStatusResponse, Error>(['bettieDailyCheckInStatus'], () =>
    getBettieDailyCheckInStatus()
  );
}
